export default __webpack_public_path__ + "static/media/TourGuidePage_02.273b69c7.jpg";